import { render, staticRenderFns } from "./MobileIdCardShot.vue?vue&type=template&id=274aaaa6&scoped=true&"
import script from "./MobileIdCardShot.vue?vue&type=script&lang=js&"
export * from "./MobileIdCardShot.vue?vue&type=script&lang=js&"
import style0 from "./MobileIdCardShot.vue?vue&type=style&index=0&id=274aaaa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274aaaa6",
  null
  
)

export default component.exports